import { isDefined } from "@clipboard-health/util-ts";
import { Chip, Stack } from "@mui/material";
import { type Agent } from "@src/appV2/Agents";
import { type Shift } from "@src/appV2/Shifts/Shift/types";

import { ShiftDurationWithLunchBreakIcon } from "./ShiftDurationWithLunchBreakIcon";
import { ShiftPayment } from "./ShiftPayment";
import { ShiftSchedule } from "./ShiftSchedule";
import { ShiftTimezone } from "./ShiftTimezone";

interface CardHeaderProps {
  shift: Shift;
  agent: Agent;
}

export function CardHeader(props: CardHeaderProps) {
  const { shift, agent } = props;

  return (
    <Stack spacing={1}>
      <Stack>
        <ShiftSchedule shift={shift} />
        <ShiftDurationWithLunchBreakIcon shift={shift} timeZone={shift.facility.tmz} />
        <ShiftTimezone timeZone={shift.facility.tmz} viewer={agent} />
        <ShiftPayment shift={shift} />
      </Stack>
      <Stack spacing={0.5} alignContent="start" direction="row">
        <Chip size="small" label={shift.agentReq} />
        <Chip size="small" label={isDefined(shift.shiftBlockId) ? "Block" : "Per Diem"} />
      </Stack>
    </Stack>
  );
}
